import clsx from 'clsx'
import { LoaderCircle } from 'lucide-react'
import styles from '@/app/styles/components/button.module.scss'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
import If from '../If'
import Typography from './Typograph'

type ButtonProps = {
  children: React.ReactNode
  onClick?: () => void
  variant?:
    | 'primary'
    | 'secondary'
    | 'simple'
    | 'default'
    | 'default-2'
    | 'green'
    | 'default-icon'
    | 'default-icon-danger'
    | 'default-icon-success'
    | 'default-icon-caution'
    | 'default-icon-info'
    | 'outlined'
  size?: 'sm' | 'md' | 'lg'
  disabled?: boolean
  loading?: boolean
  className?: string
  type?: 'button' | 'submit' | 'reset'
  title?: string
}

const SIZE_CLASSES: Record<string, string> = {
  sm: '!h-8 !text-xs !px-3',
  md: '',
  lg: '!h-12 !text-base !px-6',
}

const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  variant = 'primary',
  size = 'md',
  disabled = false,
  loading = false,
  className = '',
  type = 'button',
  title,
}) => {
  return (
    <TooltipProvider>
      <Tooltip delayDuration={100} disableHoverableContent>
        <TooltipTrigger asChild>
          <button
            className={clsx({
              [styles.button]: true,
              [styles[variant]]: variant,
              [styles.loading]: loading,
              [SIZE_CLASSES[size] || '']: !!SIZE_CLASSES[size],
              [className]: className,
              'flex items-center justify-center': true,
            })}
            onClick={onClick}
            disabled={disabled}
            type={type}
          >
            <If cond={loading}>
              <LoaderCircle className="animate-spin w-5 h-5" strokeWidth={1} />
            </If>
            <If cond={!loading}>{children}</If>
          </button>
        </TooltipTrigger>
        <If cond={!!title}>
          <TooltipContent
            className="border-1 border-[var(--foreground-300)] rounded-xl bg-[var(--background-300)]"
            sideOffset={10}
            side="bottom"
          >
            <Typography variant="p" className="text-neutral-400">
              {title}
            </Typography>
          </TooltipContent>
        </If>
      </Tooltip>
    </TooltipProvider>
  )
}

export default Button
